import React, { useState, useEffect } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { FaChevronDown, FaChevronRight, FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ toggleTab, activeTab }) => {
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState({});
  const [role, setRole] = useState(null); // state untuk role

  // Fungsi untuk mendekode token dan mengambil role
  const getRoleFromToken = () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1])); // Mendekode payload JWT
        return decodedToken.role; // Mengambil role dari payload
      } catch (e) {
        console.error('Token tidak valid:', e);
      }
    }
    return null;
  };

  // Menyimpan role saat komponen di-mount
  useEffect(() => {
    const roleFromToken = getRoleFromToken();
    setRole(roleFromToken); // Set role dari token
  }, []);

  const handleToggle = (menuKey) => {
    setOpenMenus(prev => ({ ...prev, [menuKey]: !prev[menuKey] }));
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('activeTab');
    navigate('/admin/login');
  };

  // Menu configuration
  const menuItems = [
    { type: 'single', label: 'Dashboard', tab: 'welcome' },
    { type: 'single', label: 'Gathering Dosen & Karyawan', tab: 'data' },
    {
      type: 'dropdown',
      label: 'Internship',
      key: 'internship',
      children: [
        { label: 'Intern Dashboard', tab: 'interndashboard' },
        { label: 'Applicants', tab: 'internapplicants' },
        { label: 'Setting', tab: 'internsetting' },
      ]
    },
    {
      type: 'dropdown',
      label: 'Verify',
      key: 'verify',
      children: [
        { label: 'Generate', tab: 'verify' },
        { label: 'List Doc', tab: 'allVerify' },
      ]
    },
    {
      type: 'dropdown',
      label: 'Wisuda UPI YPTK',
      key: 'wisuda',
      children: [
        { label: 'Pembekalan Wisuda', tab: 'pembekalan' },
        { label: 'Foto Wisuda', tab: 'fotoWisuda' },
      ]
    },
  ];

  // Filter menu berdasarkan role
  const filteredMenuItems = menuItems.filter(item => {
    if (role === 'admin' || role === 'administrator') {
      return true; // Admin dan Administrator dapat melihat semua menu
    }
    if (role === 'agency') {
      return item.label !== 'Internship'; // Agency tidak bisa melihat menu Internship
    }
    if (role === 'academy') {
      return item.label !== 'Gathering Dosen & Karyawan' && item.label !== 'Wisuda UPI YPTK'; // Academy tidak bisa melihat Gathering dan Wisuda UPI YPTK
    }
    if (role === 'user') {
      return item.label !== 'Internship' && item.label !== 'Verify' && item.label !== 'Gathering Dosen & Karyawan'; // User hanya bisa melihat Dashboard dan Gathering
    }
    return true;
  });

  return (
    <div className="sidebar">
      {/* Logo */}
      <div style={{ padding: '20px' }}>
        <img src="/RLA-TECH-WHITE.png" alt="Corporate Logo" style={{ maxWidth: '100%' }} />
      </div>

      <hr style={{ margin: '0px', paddingBottom: '10px' }} />

      {/* Navigation */}
      <Nav vertical className="nav">
        <NavItem>
          {filteredMenuItems.map((item, index) => {
            if (item.type === 'single') {
              return (
                <NavLink
                  key={index}
                  onClick={() => toggleTab(item.tab)}
                  active={activeTab === item.tab}
                >
                  {item.label}
                </NavLink>
              );
            } else if (item.type === 'dropdown') {
              return (
                <div className="nav-item" key={item.key}>
                  <button
                    className="nav-link expandable" 
                    onClick={() => handleToggle(item.key)}
                  >
                    {item.label} {openMenus[item.key] ? <FaChevronDown /> : <FaChevronRight />}
                  </button>
                  {openMenus[item.key] && (
                    <div className="submenu">
                      {item.children.map((child, idx) => (
                        <NavLink
                          key={idx}
                          onClick={() => toggleTab(child.tab)}
                          active={activeTab === child.tab}
                        >
                          {child.label}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
            return null;
          })}
        </NavItem>
      </Nav>

      <hr style={{ margin: '0px', paddingBottom: '10px' }} />

      {/* Logout Button */}
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          <FaSignOutAlt className="logout-icon" /> Log Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
